<template>
    <div class="steps">
        <Steps :current="stepNum">
            <Step title="信息校验" content=""></Step>
            <Step title="绑定手机" content=""></Step>
            <Step title="设置密码" content=""></Step>
            <Step title="激活完成" content=""></Step>
        </Steps>
    </div>
</template>

<script>
    export default {
        name: "steps",
        props: {
            stepNum: {
                type: Number
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// steps.vue?54133cb2